function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i1 = 0, arr2 = new Array(len); i1 < len; i1++)arr2[i1] = arr[i1];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i1 = 1; i1 < arguments.length; i1++){
        var source = arguments[i1] != null ? arguments[i1] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i1;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i1 = 0; i1 < sourceSymbolKeys.length; i1++){
            key = sourceSymbolKeys[i1];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i1;
    for(i1 = 0; i1 < sourceKeys.length; i1++){
        key = sourceKeys[i1];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import regeneratorRuntime from "regenerator-runtime";
import { context, updateContextState } from "../../components/wr-context";
import { proposalGenerator } from "../../utils/proposals/proposal-generator";
import request from "../../utils/request";
import mixpanel from "mixpanel-browser";
import { isAnalyticsEnabled } from "../analytics";
var fetchProposals = function() {
    var _param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var searchByCompanyId = _param.searchByCompanyId, rest = _objectWithoutProperties(_param, [
        "searchByCompanyId"
    ]);
    var ref;
    var filterById = searchByCompanyId || context.constants.proposals.requests.fetchProposals.shouldFetchByCompanyId ? {
        companyId: context.constants.client.companyId
    } : {
        userId: (ref = context.state.user) === null || ref === void 0 ? void 0 : ref.id
    };
    var requestParams = {
        url: "".concat(context.constants.appHost, "/api/v1/documents/search"),
        method: "GET",
        comparison: JSON.stringify(_objectSpread({}, rest)),
        query: _objectSpread({
            type: "proposal"
        }, filterById, rest),
        then: function(param) {
            var proposals = param.data, count = param.count;
            return {
                url: "".concat(context.constants.appHost, "/api/v1/attachments/attachable-id-list?").concat(context.constants.proposals.requests.fetchProposals.internalType || "internalType=proposal"),
                method: "POST",
                body: JSON.stringify({
                    data: proposals.map(function(p) {
                        return p.id;
                    })
                }),
                then: function(param) {
                    var quotes = param.data;
                    proposals.forEach(function(proposal) {
                        var quote = (quotes.find(function(quote) {
                            return quote.attachableId === proposal.id && quote.internalType === "proposal";
                        }) || {}).path;
                        proposal.quotes = quotes.filter(function(quote) {
                            return quote.attachableId === proposal.id;
                        });
                        if (quote) {
                            proposal.quote = quote;
                        }
                        if (proposal.settings) {
                            proposal.settings = JSON.parse(proposal.settings);
                        }
                    });
                    updateContextState(function(state) {
                        state.proposals = proposals;
                    });
                    return {
                        value: proposals,
                        meta: {
                            count: count
                        }
                    };
                }
            };
        }
    };
    var processRequestParams = context.utils.proposals.requests.fetchProposals.processRequestParams;
    requestParams = processRequestParams(requestParams);
    return requestParams;
};
var deleteProposal = function(id) {
    var searchByCompanyId = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).searchByCompanyId;
    return {
        deleteFetch: {
            url: "".concat(context.constants.appHost, "/api/v1/documents/document-id/").concat(id, "/delete"),
            method: "DELETE",
            then: function() {
                return fetchProposals({
                    searchByCompanyId: searchByCompanyId
                });
            }
        }
    };
};
var fetchProposal = function(query) {
    return {
        url: "".concat(context.constants.appHost, "/api/v1/documents/search"),
        query: query,
        comparison: JSON.stringify(query),
        then: function(param) {
            var data = param.data;
            var proposal = data[0];
            if (!proposal) {
                return {
                    value: null
                };
            }
            if (proposal.settings) {
                try {
                    proposal.settings = JSON.parse(proposal.settings);
                } catch (e) {}
            }
            return {
                value: data[0]
            };
        }
    };
};
var createDraftProposal = function(param) {
    var id = param.id, status = param.status, date = param.date, fromDecisionTree = param.fromDecisionTree, name = param.name, proposalName = param.proposalName, companyName = param.companyName, settings = param.settings, value = param.value, email = param.email, callback = param.callback, preserveSettings = param.preserveSettings;
    createProposal({
        id: id,
        fromDecisionTree: fromDecisionTree,
        status: status,
        name: name,
        date: date,
        proposalName: proposalName,
        companyName: companyName,
        value: value,
        handleResponse: false,
        settings: settings,
        email: email,
        callback: callback,
        preserveSettings: preserveSettings,
        proposalType: "draft"
    });
};
var createPDF = function(options) {
    var id = options.id, html = options.html, status = options.status, date = options.date, fromDecisionTree = options.fromDecisionTree, name = options.name, proposalName = options.proposalName, companyName = options.companyName, settings = options.settings, value = options.value, callback = options.callback, requiresAuth = options.requiresAuth, preserveSettings = options.preserveSettings;
    var createPDFRequest = context.utils.proposals.requests.createPDFRequest;
    var promise = createPDFRequest ? createPDFRequest(options) : request({
        url: "".concat(context.constants.appHost, "/api/v1/documents/export"),
        method: "POST",
        body: JSON.stringify({
            data: {
                html: html
            }
        })
    });
    return promise.then(function() {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(data) {
            var pdf, url, formData;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        pdf = new window.Blob([
                            data
                        ], {
                            type: "application/pdf"
                        });
                        url = window.URL.createObjectURL(pdf);
                        window.open(url, "Proposal.pdf");
                        if (!(!requiresAuth || requiresAuth && context.state.isLoggedIn)) {
                            _ctx.next = 10;
                            break;
                        }
                        formData = new window.FormData();
                        formData.append("file", pdf, "".concat(proposalName, " || ").concat(name, ".pdf"));
                        _ctx.next = 8;
                        return createProposal({
                            id: id,
                            fromDecisionTree: fromDecisionTree,
                            status: status,
                            name: name,
                            date: date,
                            formData: formData,
                            proposalName: proposalName,
                            companyName: companyName,
                            settings: settings,
                            callback: callback,
                            value: value,
                            preserveSettings: preserveSettings,
                            proposalType: "pdf"
                        });
                    case 8:
                        _ctx.next = 11;
                        break;
                    case 10:
                        {
                            context.actions.closeModal();
                        }
                    case 11:
                        return _ctx.abrupt("return", {
                            value: "",
                            doc: pdf
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }());
};
var createDocx = function(options) {
    var id = options.id, html = options.html, status = options.status, date = options.date, fromDecisionTree = options.fromDecisionTree, name = options.name, proposalName = options.proposalName, companyName = options.companyName, settings = options.settings, value = options.value, callback = options.callback, requiresAuth = options.requiresAuth, preserveSettings = options.preserveSettings;
    var createDocxRequest = context.utils.proposals.requests.createDocxRequest;
    var promise = createDocxRequest ? createDocxRequest(options) : request({
        url: "".concat(context.constants.appHost, "/api/v1/documents/export?format=docx"),
        method: "POST",
        body: JSON.stringify({
            data: {
                html: html
            }
        })
    });
    return promise.then(function(data) {
        var wordDoc = new window.Blob([
            data
        ], {
            type: "application/octet-stream"
        });
        var propName = proposalName || name;
        var link = document.createElement("a");
        link.href = URL.createObjectURL(wordDoc);
        link.download = "".concat(propName, ".docx");
        link.click();
        link.remove();
        if (!requiresAuth || requiresAuth && context.state.isLoggedIn) {
            var formData = new window.FormData();
            formData.append("file", wordDoc, "".concat(propName, ".docx"));
            createProposal({
                id: id,
                fromDecisionTree: fromDecisionTree,
                status: status,
                value: value,
                name: name,
                date: date,
                formData: formData,
                proposalName: proposalName,
                companyName: companyName,
                callback: callback,
                settings: settings,
                preserveSettings: preserveSettings,
                proposalType: "docx"
            });
        } else {
            context.actions.closeModal();
        }
        return {
            value: "",
            doc: wordDoc
        };
    });
};
var createProposal = function(param) {
    var id = param.id, fromDecisionTree = param.fromDecisionTree, status = param.status, name = param.name, date = param.date, formData = param.formData, items = param.items, options = param.options, parentType = param.parentType, parentId = param.parentId, proposalName = param.proposalName, value = param.value, companyName = param.companyName, _handleResponse = param.handleResponse, handleResponse = _handleResponse === void 0 ? true : _handleResponse, settings = param.settings, preserveSettings = param.preserveSettings, callback = param.callback, proposalType = param.proposalType;
    var proposal = proposalGenerator({
        id: id,
        companyName: companyName,
        fromDecisionTree: fromDecisionTree,
        name: name,
        date: date,
        status: status,
        items: items,
        options: options,
        parentType: parentType,
        parentId: parentId,
        proposalName: proposalName,
        value: value,
        settings: settings,
        preserveSettings: preserveSettings
    });
    return request({
        url: "".concat(context.constants.appHost, "/api/v1/documents/").concat(id ? "document-id/".concat(id, "/update") : "create"),
        method: id ? "PUT" : "POST",
        body: "".concat(JSON.stringify({
            data: proposal
        }))
    }).then(function(param) {
        var data = param.data;
        var ref;
        isAnalyticsEnabled() && mixpanel.track(context.constants.analytics.proposalGenerated, {
            companyName: companyName || ((ref = data.settings) === null || ref === void 0 ? void 0 : ref.companyName),
            companyId: data.companyId,
            createdById: data.createdBy,
            value: value !== null && value !== void 0 ? value : settings === null || settings === void 0 ? void 0 : settings.value,
            serviceIds: context.state.cart.map(function(cartItem) {
                return cartItem.id;
            }),
            type: proposalType,
            id: data.id
        });
        if (!handleResponse) {
            if (callback) {
                callback(data);
            } else {
                context.actions.resetCarts();
                context.actions.closeModal();
                context.history.push(context.getRoutePath("proposals"));
            }
            return data;
        } else {
            return request({
                url: "".concat(context.constants.appHost, "/api/v1/attachments/attachable-id/").concat(data.id, "?internalType=proposal"),
                method: "POST",
                body: formData
            }).then(function() {
                if (!handleResponse) {
                    return data;
                }
                if (callback) {
                    callback(data);
                } else {
                    context.actions.resetCarts();
                    context.actions.closeModal();
                    if (context.history.location.pathname === context.getRoutePath("proposals")) {
                        window.location.reload();
                    } else {
                        context.history.push(context.getRoutePath("proposals"));
                    }
                }
            });
        }
    }).catch(function(error) {
        isAnalyticsEnabled() && mixpanel.track(context.constants.analytics.proposalGenerationFailed, {
            error: error.message
        });
        return error;
    });
};
var updateProposal = function(_param) {
    var id = _param.id, rest = _objectWithoutProperties(_param, [
        "id"
    ]);
    return {
        url: "".concat(context.constants.appHost, "/api/v1/documents/document-id/").concat(id, "/update"),
        method: "PUT",
        body: JSON.stringify({
            data: rest
        })
    };
};
var downloadProposal = function(proposal) {
    return {
        downloadProposalFetch: {
            value: new Promise(function(resolve) {
                var html = "";
                var productRequests = proposal.settings.items.map(function(item) {
                    var id = typeof item === "string" ? item : item.id;
                    return request({
                        url: "".concat(context.constants.appHost, "/api/v1/service-catalogs/products/").concat(id)
                    });
                });
                var catalogRequest = request({
                    url: "".concat(context.constants.host, "/beta/catalogs/").concat(proposal.parentId)
                });
                var requests = [
                    catalogRequest
                ].concat(_toConsumableArray(productRequests));
                return Promise.all(requests).then(function(param) {
                    var _param = _toArray(param), catalogResponse = _param[0], itemResponses = _param.slice(1);
                    var catalog = catalogResponse.data;
                    // const items = itemResponses.map(({ data }) => data && data).filter(Boolean)
                    html += catalog.terms.setting_value;
                    var fontSizeMatcher = /font-size:\s*(\d+\w+);/g;
                    var fontSizeMatches = html.search(fontSizeMatcher);
                    console.log(fontSizeMatches);
                    console.log(html);
                    return request({
                        url: "".concat(context.constants.appHost, "/api/v1/documents/export"),
                        method: "POST",
                        body: JSON.stringify({
                            data: {
                                html: html
                            }
                        })
                    }).then(function(data) {
                        var pdf = new window.Blob([
                            data
                        ], {
                            type: "application/pdf"
                        });
                        var url = window.URL.createObjectURL(pdf);
                        window.open(url, "Proposal.pdf");
                        return {
                            value: ""
                        };
                    });
                });
            // resolve({ value: '' })
            // return {
            //   url: `${context.constants.appHost}/api/v1/documents/export`,
            //   method: 'POST',
            //   body: JSON.stringify({
            //     data: {
            //       html
            //     }
            //   })
            // }
            })
        }
    };
};
var archiveProposal = function(id, param) {
    var searchByCompanyId = param.searchByCompanyId;
    return {
        archiveFetch: {
            url: "".concat(context.constants.appHost, "/api/v1/documents/document-id/").concat(id, "/toggle-archived"),
            method: "POST",
            body: JSON.stringify({
                data: {
                    archived: true
                }
            }),
            then: function() {
                return fetchProposals({
                    searchByCompanyId: searchByCompanyId
                });
            }
        }
    };
};
var upsertProposal = function(_proposal) {
    var proposal = _objectSpread({
        type: "proposal",
        companyId: context.constants.client.companyId,
        parentId: context.constants.client.catalogIds[0],
        parentType: "catalog",
        status: "draft"
    }, _proposal);
    return request({
        url: "".concat(context.constants.appHost, "/api/v1/documents/").concat(proposal.id ? "document-id/".concat(proposal.id, "/update") : "create"),
        method: proposal.id ? "PUT" : "POST",
        body: "".concat(JSON.stringify({
            data: proposal
        }))
    });
};
export default {
    fetchProposals: fetchProposals,
    deleteProposal: deleteProposal,
    downloadProposal: downloadProposal,
    createDraftProposal: createDraftProposal,
    createPDF: createPDF,
    createDocx: createDocx,
    createProposal: createProposal,
    fetchProposal: fetchProposal,
    updateProposal: updateProposal,
    archiveProposal: archiveProposal,
    upsertProposal: upsertProposal
};
